<ng-container *ngTemplateOutlet="content" class="content"></ng-container>